import type { ProviderIdentifier } from "@/services/ProviderCookie/types";

export const VALID_PSP_VALUES: ProviderIdentifier[] = [
  "macropay",
  "stripe",
  "fake",
  "stripe_billing",
];
